import { Dimensions3D, DoorDto, LockerDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Locker } from './locker.model';

export class LockerDetails extends Locker {
  public readonly doors: DoorDto[];

  constructor(locker: LockerDto, doors: DoorDto[], towerDimensions?: Dimensions3D) {
    super(locker, towerDimensions);
    this.doors = doors;
  }
}
